<template>
  <div class="products">
    <!-- S :: #wrap -->
    <div id="wrap">
        <!-- S :: header -->
        <header id="header_wrap">
            <div class="inner">
                <h1 class="hlogo"><router-link class="sr_only" to="/">TOMATO CREW</router-link></h1>

                <!-- GNB -->
                <div class="gnb_wrap">
                    <h2 class="sr_only">menu</h2>
                    <a href="javascript:void(0);" class="btn_open_menu"><span>메뉴열기</span></a>
                    <nav id="gnb" class="gnb">
                        <ul class="gnb_menu">
                            <li><router-link to="/">홈</router-link></li>
                            <li class="on"><router-link to="/products">제품</router-link></li>
                            <li><a v-bind:href="this.$store.state.blog_link" target="_blank">블로그</a></li>
                            <li><a v-bind:href="this.$store.state.job_link" target="_blank">인재채용</a></li>
                            <li><router-link to="/company">회사소개</router-link></li>
                        </ul>
                    </nav>
                </div>
                <!-- // GNB -->
                
                <div class="select_lang" v-if="false">
                    <button type="button" class="btn_select"><span>Kor</span></button>
                    <ul class="select_list">
                        <li class="on"><button type="button">Kor</button></li> <!-- 선택 시 .on 추가 -->
                        <li><button type="button">En</button></li>
                    </ul>
                </div>
            </div>
        </header>
        <!-- E :: header -->

        <!-- S :: container -->
        <div id="content_wrap">
            
            <!-- key_visual -->
            <div class="kv_wrap">
                <div class="kv_products">
                    <div class="kv_bg"></div>
                    <div class="kv_text">
                        <p class="txt">
                            빛으로 얻을 수 있는 신체 정보의 한계는 어디까지일까요?
                            <small>토마토 크루는 디지털 헬스케어 시대를 대비하여 0.75~3㎛의 NIR(근적외선) 분광학 기반 비침습성 연속 혈당 모니터링(NiCGM) 기기 개발에 매진하고 있습니다.</small>
                        </p>
                    </div>
                </div>
            </div>
            <!-- // key visual -->

            <section class="section_prod_intro">
                <div class="cont_box left">
                    <div class="cont">
                        <strong class="title">Tomato Band</strong>
                        <div class="txt_box">
                            <p>
                                손가락 끝을 아프게 채혈하거나 혈당 측정을 위한 
                                패치를 자주 교체해야 하는 번거로움은 더 이상 없습니다.<br>
                                토마토 크루는 특허받은 기술을 토대로 비침습성 연속
                                혈당 모니터링(NiCGM) 밴드를 개발하고 있습니다.<br>
                                우리가 제공하는 밴드를 차고만 있으면 됩니다.<br>
                                더 이상 피를 뽑을 필요가 없습니다.<br>
                                근적외선 분광학 기술을 토대로 한 우리의 밴드는 혈당을 비롯한 건강 수치를 지속적으로 모니터링하여 당신의 
                                스마트폰을 통해 알려줄 것입니다.
                            </p>
                        </div>
                        <div class="noti_box">
                            <strong>2021년 테스트 기기 출시 목표</strong>
                            <span>손목에 착용하는 웨어러블 기기형 제품</span>
                        </div>
                    </div>
                    <span class="img_box"><img src="../assets/images/img_prod_intro_01.jpg"></span>
                </div>
                <div class="cont_box right">
                    <div class="cont">
                        <strong class="title">NIR 분광학 기술이란?</strong>
                        <div class="txt_box">
                            <p>
                                우리를 항상 따뜻하게 감싸주는 소중한 빛.<br>
                                스펙트럼으로 볼 때 적색 바깥쪽을 적외선이라 하며
                                그 중에서 파장이 가장 짧은 0.75~3㎛인 빛을 근적외선
                                (Near Infrared Ray)이라 합니다.
                            </p>
                            <p>근적외선은 인체에 안전하며 현재에도 소독, 근육 치료 등 의료계에서 쓰이고 있는 빛이기도 합니다.</p>
                            <p>우리는 NIR을 다시 연구했습니다. 그 결과 우리 몸 속에서
                                매 분 60~100번의 파동으로 손목을 1m/s 속도로 지나는 동맥에서 많은 데이터를 얻을 수 있다는 연구 결과에 도달했고 이를 이용하여 혈당을 연속적으로 모니터링할 수 있는 기술 개발에 매진하고 있습니다.</p>
                        </div>
                    </div>
                    <span class="img_box"><img src="../assets/images/img_prod_intro_02.jpg"></span>
                </div>
                <div class="cont_box left">
                    <div class="cont">
                        <strong class="title">디지털 헬스케어란?</strong>
                        <div class="txt_box">
                            <p>
                                한번 상상해 보세요. 손목에 차고 있는 가벼운 밴드가 있습니다. 이 밴드를 차고 있으면 내 혈당은 계속 모니터링되고 있습니다. 앗, 갑자기 수치가 올라갈 때도 있겠지요. <br>스마트폰을 통해 해당 수치를 확인하고 인슐린을 투입하거나 위험 수치까지 올라갈 것으로 예측되는 경우 담당 의료진에게 원격으로 해당 정보 알림이 전송됩니다.
                            </p>
                            <p>
                                단지 밴드 하나 차고 있었을 뿐인데, 몸의 이상 신호를 감지하여 담당 의료진이 파악하게 되어 선제 또는 빠르게 조치할 수 있게 되는 혁신적인 디지털 헬스케어 시대. 토마토 크루는 스마트 웨어러블 기기를 통한 디지털 헬스케어 혁신을 꿈꾸고 있는 기업입니다.
                            </p>
                        </div>
                    </div>
                    <span class="img_box"><img src="../assets/images/img_prod_intro_03.jpg"></span>
                </div>
            </section>
        </div>
        <!-- E :: container -->

        <!-- S :: footer -->
        <footer id="footer_wrap">
            <div class="inner">
                <div class="f_cont">
                    <ul class="menu">
                        <li>
                            <strong>
                                <small>토마토 크루가 궁금하세요?</small>
                                문의하기
                            </strong>
                            <p>
                                <button type="button" v-on:click="txtCopy()">contact@tomatocrew.io</button>
                                <input type="text" class="txtCopy" value="contact@tomatocrew.io">
                            </p>
                        </li>
                        <li>
                            <strong>
                                <small>토마토 크루에 온보딩</small>
                                채용 지원하기
                            </strong>
                            <p><a v-bind:href="this.$store.state.job_link" target="_blank" title="채용지원 바로가기">채용사이트 바로가기</a></p>
                        </li>
                    </ul>

                    <p class="f_logo"><span>TOMOTO CREW</span></p>

                    <div class="corp_info">
                        <p style="padding-bottom:4rem;">
                          <a v-bind:href="this.$store.state.termOfUse_link" target="_blank" title="이용약관">이용약관</a>
                          <a v-bind:href="this.$store.state.privacyPolicy_link" target="_blank" title="개인정보처리 방침" style="padding-left:1rem;">개인정보처리 방침</a>
                        </p>
                        <p>토마토크루 주식회사</p>
                        <p>사업자 등록번호 : 171-88-00770​</p>
                        <p class="copyright">Copyright &copy; TomatoCrew Corp. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
        <!-- E :: footer -->

    </div>
    <!-- E :: #wrap -->
  </div>
</template>

<script>
export default {
  name: 'PRODUCTS',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    txtCopy: () => {
      var $copyTxt = document.querySelector(".txtCopy");
      $copyTxt.select();
      $copyTxt.setSelectionRange(0, 99999)
      document.execCommand("copy");

      if($('.txtCopy').parent().find('.toast_wrap').length < 1) {
        $('.txtCopy').parent().append('<div class="toast_wrap"></div>')
      }

      var $wrapper = $('.toast_wrap')
      var _msg = $('<div class="toast_inner">메일주소가 복사되었습니다</div>');
      var _msgBox = _msg.appendTo($wrapper)

      _msg.appendTo($wrapper)
      $wrapper.show();
      setTimeout(function () {
        _msgBox.addClass('active');
      },300)

      _msgBox.delay(1500).queue(function() {
        $(this).removeClass('active');
        if($(this).closest('.toast_wrap').find('.active').length < 1) {
          setTimeout(function () {
            $('.toast_wrap').remove();
          }, 400)	
        }
      })
    }
  },
  mounted() {
    $('.btn_open_menu').on('click',function () {
      if(!$(this).hasClass('open')) {
        $(this).addClass('open').siblings('.gnb').addClass('show');
        $('.hlogo').addClass('on');
      }else {
        $(this).removeClass('open').siblings('.gnb').removeClass('show');
        $('.hlogo').removeClass('on');
      }
      
    })
  }
}
</script>

<style>
  @import '../assets/css/slick.css';
  @import '../assets/css/style.css';
</style>


// WEBPACK FOOTER //
// src/views/PRODUCTS.vue